import * as Factory from 'factory.ts'
import faker from 'faker'

import { UserApiModelStub } from '@webapp/platform/iam/data-access/api-models/stubs/UserApiModel.stub'
import { AuditLogChangedFieldApiModelStub } from './AuditLogChangedFieldApiModel.stub'
import { AuditLogStatuses } from '../../../entities/enums/AuditLogStatusEnum'
import { type AuditLogRecordApiModel } from '../AuditLogRecordApiModel'

export const AuditLogRecordApiModelStub =
  Factory.Sync.makeFactory<AuditLogRecordApiModel>({
    changed_on: Factory.each(() => faker.date.past(10).toISOString()),
    changed_by: UserApiModelStub.build(),
    changes: [],
    raw_changes: AuditLogChangedFieldApiModelStub.buildList(1),
    tag: AuditLogStatuses.APPROVED,
    metadata: null,
  })
